module.exports = __webpack_public_path__ + "static/media/Adidas-Originals-Gazelle-Trainers-In-Red-S76228-Lyst_thumb.8d1422ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/sneakers/Adidas-Originals-Gazelle-Trainers-In-Red-S76228-Lyst_thumb.png
// module id = 292
// module chunks = 0